export default __webpack_public_path__ + "static/media/keto_meal_times@2x.64391be7.jpg";